<template>
  <section>
    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
        <add-document>
          <b-nav-item v-b-tooltip.hover :title="$t('DOCUMENTS.ADD_DOCUMENT')">
            <i class="fal fa-plus-circle" />
            <span>{{ $t('DOCUMENTS.ADD_DOCUMENT') }}</span>
          </b-nav-item>
        </add-document>
        <b-nav-item
          active-class="active"
          :to="{ name: 'Documents.Public' }"
          v-b-tooltip.hover
          :title="$t('DOCUMENTS.PUBLISHED')"
        >
          <i class="fal fa-globe" />
          <span>{{ $t('DOCUMENTS.PUBLISHED') }}</span>
        </b-nav-item>
        <b-nav-item
          active-class="active"
          :to="{ name: 'Documents.Team' }"
          v-b-tooltip.hover
          :title="$t('DOCUMENTS.TEAM')"
        >
          <i class="fal fa-user-friends" />
          <span>{{ $t('DOCUMENTS.TEAM') }}</span>
        </b-nav-item>
        <b-nav-item
          active-class="active"
          :to="{ name: 'Documents.Drafts' }"
          v-b-tooltip.hover
          :title="$t('DOCUMENTS.DRAFTS')"
        >
          <i class="fal fa-file-edit" />
          <span>{{ $t('DOCUMENTS.DRAFTS') }}</span>
        </b-nav-item>
        
        <b-nav-item
          active-class="active"
          :to="{ name: 'Documents.Requests' }"
          v-b-tooltip.hover
          :title="$t('DOCUMENTS.REQUESTS')"
        >
          <i class="fal fa-link" />
          <span>{{ $t('DOCUMENTS.REQUESTS') }}</span>
        </b-nav-item>
      </b-nav>
    </b-navbar>

    <div class="container-fluid mt-2">
        <router-view></router-view>
    </div>
  </section>
</template>
<script>
import AddDocument from "@/components/Ledger/AddDocument";
export default {
  components: {
    AddDocument
  },
  data() {
    return {
      totalItems: 0
    };
  },
  methods: {},
  mounted: function() {}
};
</script>
<style>
</style>